<div class="faq-toolbar">
  <div class="searchContainer">
    <input
      class="searchBox"
      type="text"
      autocomplete="no-autofill"
      [(ngModel)]="searchString"
      placeholder="{{ 'core.search' | xTranslate }}"
    />
    <mat-icon class="search">search</mat-icon>
  </div>
  <div class="manage-button-right">
    <button mat-button color="primary" (click)="toggleExpandAll()" [disabled]="isEditMode" l10nTranslate>
      core.expandall
    </button>
    <button
      mat-button
      color="primary"
      class="manage-left"
      (click)="toggleEditMode()"
      *ngxPermissionsOnly="'Help Admin'"
      [disabled]="isEditMode"
      l10nTranslate
    >
      core.manageFaqContent
    </button>
  </div>
</div>
<miq-faq-list-item
  *ngFor="let faq of editedFAQList | faqSearch: searchString"
  [faq]="faq"
  (updateFaqEvent)="updateFaq($event)"
  (deleteFaqEvent)="deleteFaq($event)"
  (likeFaqEvent)="likeFaq($event)"
>
</miq-faq-list-item>

<div *ngIf="addingFaq">
  <miq-faq-list-item
    [faq]="newFaq"
    (updateFaqEvent)="updateNewFaq($event)"
    (deleteFaqEvent)="deleteNewFaq()"
  ></miq-faq-list-item>
</div>

<div *ngIf="isEditMode">
  <button mat-icon-button [disabled]="addingFaq" class="add-faq" (click)="addFaq()">
    <mat-icon>add</mat-icon> <span l10nTranslate>core.addFaq</span>
  </button>
</div>

<div mat-dialog-actions *ngIf="isEditMode">
  <button mat-button color="primary" (click)="cancelChanges()" l10nTranslate>core.cancel</button>
  <button mat-flat-button color="primary" [disabled]="disableSave" (click)="saveChanges()" l10nTranslate>
    admin.save
  </button>
</div>
